import { render } from "./PatientAccountability.vue?vue&type=template&id=d88a55b4&scoped=true"
import script from "./PatientAccountability.vue?vue&type=script&lang=js"
export * from "./PatientAccountability.vue?vue&type=script&lang=js"

import "./PatientAccountability.vue?vue&type=style&index=0&id=d88a55b4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d88a55b4"]])

export default __exports__